export default __webpack_public_path__ + "static/media/glassesLeft.1136b2d0.svg";